import angular from 'angular';
import '../../shared.module';
import template from './skeleton.component.html';
import './skeleton.component.scss';

class SkeletonController {
  $onInit() {
    this.width = this.width || '100%';
    this.height = this.height || '14px';
    this.rounded = this.rounded || false;
  }
}

angular.module('app.shared').component('cpSkeleton', {
  bindings: {
    width: '@',
    height: '@',
    rounded: '<'
  },
  controller: SkeletonController,
  controllerAs: 'vm',
  template
});
